import { render, staticRenderFns } from "./searchbrochures.vue?vue&type=template&id=ba1d332e&scoped=true"
import script from "./searchbrochures.vue?vue&type=script&lang=js"
export * from "./searchbrochures.vue?vue&type=script&lang=js"
import style0 from "./searchbrochures.vue?vue&type=style&index=0&id=ba1d332e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1d332e",
  null
  
)

export default component.exports